import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ArrowDownSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ArrowDownSVG;
